import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Params, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';

import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../../retailer.service';
import { ZipCodes } from 'src/app/features-common/constants/ZipCodes';
import { CurrencyPipe, formatDate } from '@angular/common';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { LinkedRetailerComponent } from './linked-retailer/linked-retailer.component';
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();

@Component({
  selector: 'app-edit-retailer',
  templateUrl: './edit-retailer.component.html',
  styleUrls: ['./edit-retailer.component.scss']
})
export class EditRetailerComponent extends FeaturesBaseComponent implements OnInit {
  @Input() salesReps
  @Input() businessTypes
  @Input() pricelists
  @Input() retailerDetails
  @Input() RetailerId
  @Input() allLinkableRetailers
  @Input() currentLinkedRetailers

  offHoursTransactionCount;
  offHoursTransactionAmount;
  thresholdAmount;
  invoiceType: any;
  addPaymentInfoForm: FormGroup;
  emailRegx = /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  phoneRegx = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/; 
  numberMask = createNumberMask({
    prefix: '$ ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol :',',
    allowDecimal :true,
  })

  autoReloadStatus: boolean;
  
  autoPaymentStatus: boolean;
  isCreditLine: boolean;
  ipAddressStatus: boolean;
  ivrAccess: boolean = false;
  isIpAddress: boolean;
  smsNotificationStatus: boolean;
  emailNotificationStatus: boolean = false;
  isAutoReLoad: boolean = false;
  transactionAmtPerhr: number[];
  managerName;
  retailerData: any = [];
  assignSalesRepsId: any;
  retailerAccountNum: any;
  usStateZips: any;
  currentAmount: number;
  phone: (string | RegExp)[];
  transactionPerHr: number[];
  paymentOptions: any = [];
  creditLineStatus: boolean = false;
  selectedsalesrep: any;
  retailerUserName: any;
  statusOptions: string[];
  selectedStatus: any;
  disableStatus: boolean = false;
  userRole:string= '';
  showCard: boolean = true;
  constructor(private cdref: ChangeDetectorRef, private fb: FormBuilder, public dialog: MatDialog, private retailerService: RetailerService, private router: Router) {
    super();
    const token: string = localStorage.getItem('accessToken'); 
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
   

    this.phone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  ngAfterContentChecked() {

    this.cdref.detectChanges();

  }

  allCharWithAmprecendMask(rawValue: string): RegExp[] {
    const mask = /^[.\/&\w\s]*$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }


  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['salesReps']) {
      this.salesReps = changes['salesReps'].currentValue;
      
    }
    if (changes['businessTypes']) {
      this.businessTypes = changes['businessTypes'].currentValue;
    }
    if (changes['pricelists']) {
      this.pricelists = changes['pricelists'].currentValue;
    }
    if (changes['RetailerId']) {
      this.RetailerId = changes['RetailerId'].currentValue;

    }
    if (changes['retailerDetails']) {
      this.retailerDetails = changes['retailerDetails'].currentValue;
      this.assignData();
    }    
    //retailerDetails
  }

  

  /*checkIsCreditline(e) {
    this.creditLineStatus = e.checked;
    if (this.creditLineStatus) {
      this.addPaymentInfoForm.controls['createCreditLine'].setValidators(Validators.required);
    } else {
      this.addPaymentInfoForm.controls['createCreditLine'].clearValidators();
    }
    this.addPaymentInfoForm.controls['createCreditLine'].updateValueAndValidity();
  }*/
  checkIpAddressStatus(e) {
    this.ipAddressStatus = e.checked;
    if (this.ipAddressStatus) {
      this.addPaymentInfoForm.controls['ipAddressStatus'].setValidators(Validators.required);
    } else {
      this.addPaymentInfoForm.controls['ipAddressStatus'].clearValidators();
    }
    this.addPaymentInfoForm.controls['ipAddressStatus'].updateValueAndValidity();
  }
  checkIsIvr(e) {
    this.ivrAccess = e.checked;
    if (this.ivrAccess) {
      this.addPaymentInfoForm.controls['ivrNumber'].setValidators(Validators.required);
      this.addPaymentInfoForm.controls['ivrCode'].setValidators(Validators.required);
    } else {
      this.addPaymentInfoForm.controls['ivrCode'].clearValidators();
      this.addPaymentInfoForm.controls['ivrNumber'].clearValidators();
    }
    this.addPaymentInfoForm.controls['ivrNumber'].updateValueAndValidity();
    this.addPaymentInfoForm.controls['ivrCode'].updateValueAndValidity();
  }
  checkautoReloadStatus(e) {
    this.autoReloadStatus = e.checked;
    if (this.autoReloadStatus) {
      this.addPaymentInfoForm.controls['threshold'].setValidators(Validators.required);
      this.addPaymentInfoForm.controls['autoReloadAmount'].setValidators(Validators.required);
    } else {
      this.addPaymentInfoForm.controls['autoReloadAmount'].clearValidators();
      this.addPaymentInfoForm.controls['threshold'].clearValidators();
    }
    this.addPaymentInfoForm.controls['threshold'].updateValueAndValidity();
    this.addPaymentInfoForm.controls['autoReloadAmount'].updateValueAndValidity();
  }
  checkautoPaymentStatus(e) {
    this.autoPaymentStatus = e.checked;
  }
  checkIsTextNotify(e) {
    this.smsNotificationStatus = e.checked;
  }
  checkEmailNotificationStatusNotify(e) {
    this.emailNotificationStatus = e.checked;
  }
  assignData(){
    if (this.retailerDetails && this.retailerDetails) {
      let _retailerData: any = this.retailerDetails
      
      
      this.selectedsalesrep = _retailerData.saleRepUserId;
     
      this.retailerData = {
        retailerId: _retailerData.retailerDetails.retailerId,
        retailerCode: _retailerData.retailerDetails.retailerCode,
        retailerUserName: _retailerData.userAuthentication.userName,
        retailerAccountNum: _retailerData.retailerAccounts.retailerAccountNum,
        accountType: _retailerData.retailerAccounts.retailerType,
        businessName: _retailerData.retailerDetails.businessName,
        businessType: _retailerData.retailerDetails.businessType,
        businessNumber: _retailerData.retailerDetails.businessNumber,
        dbaName: _retailerData.retailerDetails.dbaName,
        address: _retailerData.retailerDetails.address1,
        city: _retailerData.retailerDetails.city,
        state: _retailerData.retailerDetails.state,
        status: _retailerData.retailerDetails.retailerStatus,
        zipCode: _retailerData.retailerDetails.zip,
        firstName: _retailerData.firstName,
        lastName: _retailerData.lastName,
        email: _retailerData.retailerDetails.email,
        otpMobileNumber: _retailerData.retailerDetails.otpMobileNumber,
        retailerName: _retailerData.retailerStaffDetails.ownerName,
        comments: _retailerData.retailerDetails.retailerComments,
        businessCertificate: _retailerData.retailerDetails.retailerCertificateNumber,
        language: _retailerData.retailerDetails.language,
        confirmationNumber: _retailerData.retailerDetails.confirmationNumber,
        assignPriceList: _retailerData.retailerPricelistAssignment.priceList,
        paymentOption: _retailerData.retailerPaymentOptions.paymentOptionType,
        invoiceOption: _retailerData.retailerPaymentOptions.invoiceType,
        managerName: _retailerData.retailerStaffDetails.managerName,
        managerNumber: _retailerData.retailerStaffDetails.managerNumber,
        smsNotificationStatus: _retailerData.retailerNotifications.smsNotification,
        smsNotification: _retailerData.retailerNotifications.numbers,
        emailNotificationStatus: _retailerData.retailerNotifications.emailNotification,
        emailNotification: _retailerData.retailerDetails.email,
        tierLevel: _retailerData.retailerDetails.tierLevel,
        ipAddress: _retailerData.retailerPlatformAccess.ipAddress,
        ivrAccess: _retailerData.retailerPlatformAccess.ivrAccess,
        ivrNumber: _retailerData.retailerPlatformAccess.ivrText,
        ivrCode: _retailerData.retailerPlatformAccess.ivrCode,
        autoReloadStatus: _retailerData.retailerAccounts.autoReloadThresholdStatus,
        autoPaymentStatus: _retailerData.retailerPaymentOptions.autoPaymentStatus,
        autoReloadAmount: _retailerData.retailerAccounts.autoReloadThresholdAmount,
        threshold: _retailerData.retailerAccounts.thresholdMinAmt,
        transactionCountPerhr: _retailerData.retailerAccounts.businessTransLimitPerHr,
        transactionAmtPerhr: _retailerData.retailerAccounts.businessTransLimitAmtPerHr,
        offTransactionCountPerhr: _retailerData.retailerAccounts.offBusinessTransLimitPerHr,
        offTransactionAmtPerhr: _retailerData.retailerAccounts.offBusinessTransLimitAmtPerHr,
        currentAmount: _retailerData.retailerAccountSummary.currentAmount,
        creditLineStatus: _retailerData.retailerAccountSummary.creditLineStatus
      }
      
      // let _salesrep = this.salesReps.filter(e => e.userId == _retailerData.retailerSalesRepAssignment.userId)[0].userId;
      this.addPaymentInfoForm.controls['assignSalesReps'].setValue(this.selectedsalesrep);

      if (this.retailerData && this.retailerData ){
        this.addPaymentInfoForm.get("retailerId").setValue(this.retailerData.retailerId);
        this.addPaymentInfoForm.get("retailerCode").setValue(this.retailerData.retailerCode);
        this.retailerAccountNum = this.retailerData.retailerAccountNum;
        this.retailerUserName = this.retailerData.retailerUserName;
        this.addPaymentInfoForm.get("retailerAccountNum").setValue(this.retailerData.retailerAccountNum);
        this.addPaymentInfoForm.get("accountType").setValue(this.retailerData.accountType);
        this.addPaymentInfoForm.get("businessName").setValue(this.retailerData.businessName);
        this.addPaymentInfoForm.get("businessType").setValue(this.retailerData.businessType);
        let _businessNumber = this.retailerData.businessNumber;
        if (this.retailerData.businessNumber?.length == 11) {
          _businessNumber = this.retailerData.businessNumber.substring(1);
        }
        this.addPaymentInfoForm.get("businessNumber").setValue(_businessNumber);
        this.addPaymentInfoForm.get("dbaName").setValue(this.retailerData.dbaName);
        this.addPaymentInfoForm.get("address").setValue(this.retailerData.address);
        this.addPaymentInfoForm.get("city").setValue(this.retailerData.city);
        this.addPaymentInfoForm.get("state").setValue(this.retailerData.state);
        this.addPaymentInfoForm.get("status").setValue(this.retailerData.status);
        this.selectedStatus = this.retailerData.status;
        if(this.retailerData.status == 'InActive'){
          this.disableStatus = true;
        }
        this.addPaymentInfoForm.get("zipCode").setValue(this.retailerData.zipCode);
        //this.addPaymentInfoForm.get("retailerName").setValue(`${this.retailerData.firstName} ${this.retailerData.lastName}`);
        
        this.addPaymentInfoForm.get("firstName").setValue(this.retailerData.firstName);
        this.addPaymentInfoForm.get("lastName").setValue(this.retailerData.lastName);

        this.addPaymentInfoForm.controls['email'].setValue(this.retailerData.email);
        //let _otpMobileNum = this.retailerData.otpMobileNumber;
        //if (this.retailerData.otpMobileNumber.length == 11) {
        //  _otpMobileNum = this.retailerData.otpMobileNumber.substring(1);
        //}
        this.addPaymentInfoForm.get("otpMobileNumber").setValue(this.retailerData.otpMobileNumber);
        this.addPaymentInfoForm.get("comments").setValue(this.retailerData.comments);
        this.addPaymentInfoForm.get("businessCertificate").setValue(this.retailerData.businessCertificate);
        this.addPaymentInfoForm.get("language").setValue(this.retailerData.language);
        this.addPaymentInfoForm.get("confirmationNumber").setValue(this.retailerData.confirmationNumber);
        this.addPaymentInfoForm.get("assignPriceList").setValue(this.retailerData.assignPriceList);
        this.addPaymentInfoForm.get("paymentOption").setValue(this.retailerData.paymentOption);
        this.addPaymentInfoForm.get("invoiceOption").setValue(this.retailerData.invoiceOption);
        this.addPaymentInfoForm.get("managerName").setValue(this.retailerData.managerName);
        this.addPaymentInfoForm.get("tierLevel").setValue(this.retailerData.tierLevel);
        this.addPaymentInfoForm.controls['smsNotificationStatus'].setValue((this.retailerData.smsNotificationStatus == "Yes"));
        this.smsNotificationStatus = (this.retailerData.smsNotification == "Yes");
        this.addPaymentInfoForm.controls['emailNotificationStatus'].setValue((this.retailerData.emailNotificationStatus == "Yes"));
        this.emailNotificationStatus = (this.retailerData.emailNotificationStatus == "Yes");

        if (this.retailerData.ipAddress && this.retailerData.ipAddress != '') {
          this.addPaymentInfoForm.controls['ipAddressStatus'].setValue(true);
          this.ipAddressStatus = true;
        }
        else {
          this.addPaymentInfoForm.controls['ipAddressStatus'].setValue(false);
          this.ipAddressStatus = false;
        }
        this.addPaymentInfoForm.controls['ipAddress'].setValue(this.retailerData.ipAddress);
        this.ivrAccess = (this.retailerData.ivrAccess == "Yes");
        this.addPaymentInfoForm.controls['ivrAccess'].setValue(this.ivrAccess);
        this.addPaymentInfoForm.controls['ivrNumber'].setValue(this.retailerData.ivrNumber);
        this.addPaymentInfoForm.controls['ivrCode'].setValue(this.retailerData.ivrCode);
        this.addPaymentInfoForm.controls['autoReloadStatus'].setValue((this.retailerData.autoReloadStatus == "Yes"));
        this.autoReloadStatus = (this.retailerData.autoReloadStatus == "Yes");
        if (!this.autoReloadStatus) {
          this.addPaymentInfoForm.get("autoReloadAmount").clearValidators();
        }
        this.addPaymentInfoForm.controls['autoPaymentStatus'].setValue((this.retailerData.autoPaymentStatus == "Yes"));
        this.autoPaymentStatus = (this.retailerData.autoPaymentStatus == "Yes");
       
        this.addPaymentInfoForm.controls['autoReloadAmount'].setValue(this.retailerData.autoReloadAmount);
        this.addPaymentInfoForm.controls['threshold'].setValue(this.retailerData.threshold);
        this.addPaymentInfoForm.controls['transactionCountPerhr'].setValue(this.retailerData.transactionCountPerhr);
        this.addPaymentInfoForm.controls['transactionAmtPerhr'].setValue(this.retailerData.transactionAmtPerhr);
        this.addPaymentInfoForm.controls['offTransactionCountPerhr'].setValue(this.retailerData.offTransactionCountPerhr);
        this.addPaymentInfoForm.controls['offTransactionAmtPerhr'].setValue(this.retailerData.offTransactionAmtPerhr);
        this.currentAmount = this.retailerData.currentAmount;
        //this.currentAmount = this.retailerData.currentAmount.toFixed(2);
        let _managerNumber = this.retailerData.managerNumber;
        
        if (this.retailerData.managerNumber && this.retailerData.managerNumber.length == 11) {
          _managerNumber = this.retailerData.managerNumber.substring(1);
        }
        this.addPaymentInfoForm.controls['managerNumber'].setValue(_managerNumber);
        if(this.addPaymentInfoForm.get('assignSalesReps').value && this.addPaymentInfoForm.get('assignSalesReps').value){
          this.addPaymentInfoForm.controls['assignSalesReps'].clearValidators;
          this.addPaymentInfoForm.controls['assignSalesReps'].updateValueAndValidity();
        } 
        this.addPaymentInfoForm.updateValueAndValidity();
        // previous values
        // this.addPaymentInfoForm.controls['assignSalesReps'].setValue(this.retailerData.saleRepUserId);
        // this.selectedsalesrep = this.retailerData.saleRepUserId;
      }
    }
  }
  ngOnInit(): void {
    super.ngOnInit();
    //    if (localStorage.getItem('retailerId') && localStorage.getItem('retailerId')) {
    //      this.selectedRetailerId = parseInt(localStorage.getItem('retailerId'));
    //    }
    
    this.offHoursTransactionCount = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15];
    this.offHoursTransactionAmount = [0, 25, 50, 75, 100, 125, 150, 175, 200,250,300];
    this.thresholdAmount = [25, 50, 75, 100, 125, 150, 175, 200, 225, 250,300];
    this.transactionAmtPerhr = [0, 50, 100, 200, 300, 400, 1000,1500]; 
    this.transactionPerHr = [10, 20, 30, 40, 50];

    this.paymentOptions = ['ACH', 'Credit Card', 'Deposit']
    this.statusOptions = ['Active', 'Hold', 'InActive']
    this.invoiceType = [
    {type:'Weekly',translate:'pages.newRetailer.weekly'},
    {type:'Daily',translate:'pages.newRetailer.daily'},
    {type:'Semi-weekly',translate:'pages.newRetailer.semiWeekly'},
    {type:'Bi-Weekly',translate:'pages.newRetailer.biWeekly'},
    {type:'Monthly',translate:'pages.newRetailer.monthly'}]
    //this.invoiceType = ['Weekly','Daily','Semi-weekly','Bi-Weekly','Monthly']  

    this.usStateZips = ZipCodes.USAStatesShort;
    this.initForm();

    //Call to fetch retailer detailer based on IP param

       
  }

  initForm() {
    this.addPaymentInfoForm = new FormGroup({
      retailerId: new FormControl('', Validators.required),
      retailerCode: new FormControl(''),
      retailerAccountNum: new FormControl(''),
      accountType: new FormControl(''),
      businessName: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
      businessType: new FormControl('', Validators.required),
      businessNumber: new FormControl('', [Validators.required, Validators.pattern(this.phoneRegx)]),
      dbaName: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
      address: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zipCode: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')]),
      status: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.pattern(this.emailRegx)]),
      otpMobileNumber: new FormControl(''),
      //retailerName: new FormControl('', Validators.required),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      comments: new FormControl(''),
      businessCertificate: new FormControl('N/A', [Validators.required]),
      confirmationNumber: new FormControl(''),
      language: new FormControl('N/A'),
      assignPriceList: new FormControl('', Validators.required),
      assignSalesReps: new FormControl(''),
      paymentOption: new FormControl(''),
      invoiceOption: new FormControl(''),
      managerName: new FormControl(''),
      managerNumber: new FormControl(''),
      tierLevel: new FormControl(''),
      smsNotificationStatus: new FormControl(false),
      emailNotificationStatus: new FormControl(false),
      ipAddressStatus: new FormControl(''),
      ipAddress: new FormControl(''),
      ivrAccess: new FormControl(false),
      ivrNumber: new FormControl(''),
      ivrCode: new FormControl(''),
      autoReloadStatus: new FormControl(''),
      autoPaymentStatus: new FormControl(''),
      autoReloadAmount: new FormControl(''),
      threshold: new FormControl(''),
      transactionCountPerhr: new FormControl('', Validators.required),
      transactionAmtPerhr: new FormControl('', Validators.required),
      offTransactionCountPerhr: new FormControl('', Validators.required),
      offTransactionAmtPerhr: new FormControl('', Validators.required),
    })
  }
  get f() {
    //
    return this.addPaymentInfoForm.controls;
  }
  onAddRetailerPaymentSubmit() {
    this.setSubmitParameters(this.addPaymentInfoForm);
  }

  setSubmitParameters(addPaymentInfoForm: FormGroup) {
    
    let _managerNumber: any = addPaymentInfoForm.get('managerNumber').value;
    let _businessNumber: any = addPaymentInfoForm.get('businessNumber').value;
    let _otpMobileNumber: any = addPaymentInfoForm.get('otpMobileNumber').value;
    //if (_managerNumber?.length > 0) { _managerNumber = _managerNumber.replace(/\D+/g, ''); }
    //if (_businessNumber?.length > 0) { _businessNumber = _businessNumber.replace(/\D+/g, ''); }
    //if (_otpMobileNumber?.length > 0) { _otpMobileNumber = _otpMobileNumber.replace(/\D+/g, ''); }


    let httpParams: Params = {
      retailerId: addPaymentInfoForm.get('retailerId').value,
      retailerCode: addPaymentInfoForm.get('retailerCode').value,
      accountType: addPaymentInfoForm.get('accountType').value,
      businessName: addPaymentInfoForm.get('businessName').value,
      businessType: addPaymentInfoForm.get('businessType').value,
      businessNumber: _businessNumber,
      dbaName: addPaymentInfoForm.get('dbaName').value,
      address: addPaymentInfoForm.get('address').value,
      city: addPaymentInfoForm.get('city').value,
      state: addPaymentInfoForm.get('state').value,
      status: addPaymentInfoForm.get('status').value,
      zipCode: addPaymentInfoForm.get('zipCode').value,
      email: addPaymentInfoForm.get('email').value,
      otpMobileNumber: _otpMobileNumber,
      //retailerName: addPaymentInfoForm.get('retailerName').value,
      firstName: addPaymentInfoForm.get('firstName').value,
      lastName: addPaymentInfoForm.get('lastName').value, 
      comments: addPaymentInfoForm.get('comments').value,
      businessCertificate: addPaymentInfoForm.get('businessCertificate').value,
      language: addPaymentInfoForm.get('language').value,
      confirmationNumber: addPaymentInfoForm.get('confirmationNumber').value,
      assignPriceList: addPaymentInfoForm.get('assignPriceList').value,
      assignSalesReps: addPaymentInfoForm.get('assignSalesReps').value,
      paymentOption: addPaymentInfoForm.get('paymentOption').value,
      invoiceOption: addPaymentInfoForm.get('invoiceOption').value,
      managerName: addPaymentInfoForm.get('managerName').value,
      managerNumber: _managerNumber,
      smsNotificationStatus: addPaymentInfoForm.get('smsNotificationStatus').value? 'Yes' : 'No',
      smsNotification: this.retailerData.smsNotification,
      emailNotificationStatus: addPaymentInfoForm.get('emailNotificationStatus').value ? 'Yes' : 'No',
      emailNotification: this.retailerData.emailNotification,
      ipAddressStatus: addPaymentInfoForm.get('ipAddressStatus').value ? 'Yes' : 'No',
      ipAddress: addPaymentInfoForm.get('ipAddress').value,
      ivrAccess: this.ivrAccess ? 'Yes' : 'No',
      ivrNumber: addPaymentInfoForm.get('ivrNumber').value,
      ivrCode: addPaymentInfoForm.get('ivrCode').value,
      autoReloadStatus: addPaymentInfoForm.get('autoReloadStatus').value ? 'Yes' : 'No',
      autoPaymentStatus: addPaymentInfoForm.get('autoPaymentStatus').value ? 'Yes' : 'No',
      //autoReloadAmount: addPaymentInfoForm.get('autoReloadAmount').value.replace('$','').replace(',','').replace(' ',''),
      autoReloadAmount: typeof addPaymentInfoForm.get("autoReloadAmount").value == 'string' ? addPaymentInfoForm.get("autoReloadAmount").value.replace(/[^a-zA-Z0-9 ]/g, "") : addPaymentInfoForm.get("autoReloadAmount").value,
      threshold: addPaymentInfoForm.get('threshold').value,
      transactionCountPerhr: addPaymentInfoForm.get('transactionCountPerhr').value,
      transactionAmtPerhr: addPaymentInfoForm.get('transactionAmtPerhr').value,
      offTransactionCountPerhr: addPaymentInfoForm.get('offTransactionCountPerhr').value,
      offTransactionAmtPerhr: addPaymentInfoForm.get('offTransactionAmtPerhr').value,
      createCreditLine: this.currentAmount,
      creditLineStatus: (this.retailerData.creditLineStatus || this.retailerData.creditLineStatus == 'Yes') ? 'Yes' : 'No',
    }
    this.retailerService.addRetailerPaymentInfo(httpParams).subscribe(res => {
      if (res && res) { 
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_111") || res.responseStatus == 'Success'){
          this.router.navigate(['features/retailers/allretailers'])
          this.toastrService.success('Retailer updated successfully', 'Success', {
            timeOut: 3000,
          });   
          //this.reloadComponent();  
          //return;   
      }
      }
    });
  }


  onCancel() {
    // for (const name in this.addPaymentInfoForm.controls) {
    //   if (this.addPaymentInfoForm.controls[name].invalid) {
    //    
    //   } else {
    //    
    //   }

    // }
    
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {

        this.addPaymentInfoForm.reset()
        this.router.navigate(['features/retailers/allretailers'])
      }
    });
  }

  checkSubmitDisplayed() {
    return !(this.addPaymentInfoForm.valid && !this.addPaymentInfoForm.pristine); 
  }

  onCancelAutoReload(e) {
    return
  }
  onDownlaodPriceList(e) { 
    let downlaodPriceListname = this.addPaymentInfoForm.get('assignPriceList').value;
    if(downlaodPriceListname != null){
      this.retailerService.pricelistdownloadProdcuts(downlaodPriceListname).subscribe(res => {
        //alert("hello");  
        saveAs(res, downlaodPriceListname+" - Products.csv") 
          this.toastrService.success('Downloaded successfully', 'Success', {
            timeOut: 3000,
          });  
      });
    }
    return
  }
  onLinkedAcountsClick(e) {
    this.retailerService.getRetailersLinkedById(this.RetailerId).subscribe(
      res => {
        if(res['httpcode'] == 200){
          this.currentLinkedRetailers =res['data']
          const dialogRef = this.dialog.open(LinkedRetailerComponent, {
            
            maxHeight:'80Vh',
            minHeight: '400px',
            panelClass:'linked-model',
            data: {
              allLinkableRetailers: this.allLinkableRetailers,
              currentLinkedRetailers: this.currentLinkedRetailers,
              retailerId : this.RetailerId
            }
          });
          dialogRef.afterClosed().subscribe(res => {
           
          })
          return
        }
      }
    );
    
  }

  reloadComponent() {
    //let currentUrl = this.router.url;
    let currentUrl = this.router.url;

        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }
    
    disableOption(status){
      //alert(status)
      if(status == 'InActive') return true;
      //if(status == 'Active' || status == 'Hold') return false;
    } 
    rolecheck(){  
      if (this.userRole == "Sales Rep"){
        return true;
      }else{
        return false;
      }
    }
    readonly(){  
      //alert("hello")
      if (this.userRole == "Customer Service"){
        //alert(this.userRole)
        return true;
      }else{
        return false;
      }
    } 
    onsalesrepSelected(e: MatSelectChange){
      let _salesrep = e.value;
      let params: any = {
        salesRepId:_salesrep
      }
      this.retailerService.getPricelists(params).subscribe(
        res => {
          let data: any = res;
          if (data.httpcode == 200) {
            this.pricelists = data.data;
            
          }
        });
      }
  }